// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_3w9fz","text":"index_text_2RBdJ","textHidden":"index_textHidden_3lzrs","contentBox":"index_contentBox_1WZOo","boxTitle":"index_boxTitle_38l5Y"};